import { FC, ReactNode, useState } from "react";

import ManagerCodeModal from "./manager-code-modal/ManagerCodeModal";
import { useAppSelector } from "../../hooks";

interface AssignNewRouteProps {
  children: ReactNode;
  onSuccess: () => void;
}

const AssignNewRoute: FC<AssignNewRouteProps> = ({ children, onSuccess }) => {
  const [openModal, setOpenModal] = useState(true);
  const { user } = useAppSelector((state) => state.auth);

  return (
    <>
      {children}
      <ManagerCodeModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Assign New Route"
        task="assign a new route"
        onDone={() => {
          setOpenModal(false);
          onSuccess();
        }}
        actionType="ASSIGN_NEW_ROUTE"
        requestedByUserId={user?.id}
      />
    </>
  );
};

export default AssignNewRoute;
